<template>
    <PlainPage>
        <template v-if="!isSuccess">
            <div class="py-4 px-7.5">
                <div class="flex items-center gap-5 mb-9">
                    <div class="flex-none">
                        <img src="@/assets/register/TTB_ECare_Card_02@2x.png" class="h-20" alt=""/>
                    </div>
                    <div class="text-a-blue-0056ff font-bold text-center">
                        กรอกข้อมูลส่วนบุคคล
                        ของผู้เอาประกันภัย
                    </div>
                </div>
                <div class="max-w-2xl m-auto">
                    <FormRegister ref="formRegister" v-model="formValid"></FormRegister>
                    <div class="mt-9">
                        <MainButton @click="clickSubmit()" size="lg" color="orange-2" :disabled="!formValid">
                            ลงทะเบียน
                        </MainButton>
                    </div>
                </div>
                <div class="mt-12 flex justify-end">
                    <img src="@/assets/logo/Logo-TMB.svg" alt=""/>
                </div>
            </div>
        </template>
        <template v-else>
            <TtbRegisterSuccess />
        </template>
    </PlainPage>
</template>
<script>
import CacheHelper from '@/helper/CacheHelper';
//component
import PlainPage from '@/components/Layout/Page/PlainPage.vue';
import FormRegister from '../component/FormRegister/FormRegister.vue';
import MainButton from '@/components/Button/MainButton.vue';
import TtbRegisterSuccess from '../component/TtbRegister/TtbRegisterSuccess.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import RegisterApi from '../service/RegisterApi';
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: 'Register',
    mixins: [ModalMixin],
    components: {
        FormRegister,
        MainButton,
        PlainPage,
        TtbRegisterSuccess
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function () {
        return {
            formValid: false,
            isSuccess: false
        };
    },
    created: function () {
        this.initLineIdToken(); //? For register line
    },
    methods: {
        initLineIdToken: function () {
            let cache = new CacheHelper();
            let cacheLine = cache.getCache('line_user_id');

            if (cacheLine == null) {
                this.requestLineData()
            }
        },
        clickSubmit: async function () {
            this.tracking.event("register_ttb_page", "click_confirm_register", "", "");
            this.modal.loadingModal.show();
            let registerData = await this.apiRegister();
            this.modal.loadingModal.hide();

            if (registerData != null && registerData == true) {
                this.clearFormCache();
                this.$nextTick(() => {
                    this.isSuccess = true
                })
            } else {
                // unexpected case (ไม่ควรเกิดเคสนี้)
                this.modal.alertModal
                    .clearModal()
                    .setMsg("ไม่สามารถบันทึกข้อมูลได้")
                    .show();
            }
        },
        requestLineData: function () {
            // window.location.replace('/Landing.aspx?target_page=ConsentQr.aspx');
        },
        apiRegister: function () {
            return new Promise((resolve) => {
                /**@type {import("../model/RegisterModel").RegisterModel} */
                let data = this.$refs.formRegister.getValue()
                // console.log(data.getParams())
                RegisterApi.apiRegister(data).subscribe({
                    next: (res) => {
                        if (res.data.status == "success") {
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    },
                    error: (err) => {
                        resolve(null);
                        if (err.code == '401') { // Line id token expire
                            this.modal.alertModal
                                .clearModal()
                                .setMsg(err.message)
                                .show();
                            this.modal.alertModal.onClickOk(() => {
                                // got to landing line then comeback to consent page
                                this.requestLineData()
                            });
                        } else {
                            this.errorApi(err);
                        }
                    },
                });
            });
        },

        showSuccess: function (registerData) {
            console.log(registerData);

            this.modal.registerSuccessModal
                .clearModal()
                .setMsg(`register success get ${registerData} points`)
                .show();
        },
        clearFormCache: function () {
            let cache = new CacheHelper('session');
            cache.removeCache('ttb-register.model');
        },
    },
}
</script>
